import NavBar from './components/navbar';
import { useState } from 'react';
import { faqs } from './constants/data';

export default function FAQ() {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const toggleFAQ = (index) => {
    if (index === expandedIndex) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };
  return (
    <div class='flex flex-col justify-center items-center py-2'>
      <NavBar />
      <div class='bg-wheatBg py-12 w-full mt-24'>
        <p class='font-bold text-[52px] text-center'>FAQ</p>
      </div>
      <div
        class='container mx-auto mb-8 lg:w-[55%] flex flex-col justify-center items-center mt-6 rounded-xl p-8'
        style={{
          backgroundImage:
            'linear-gradient(135deg, #f9f9ff, rgba(189, 255, 239, .2))',
        }}
      >
        <div className='space-y-4 w-full lg:w-[80%]'>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className='bg-transparent border-b-[1px] border-gray-300'
            >
              <div
                className='flex justify-between items-center p-4 cursor-pointer'
                onClick={() => toggleFAQ(index)}
              >
                <h2 className='text-lg font-semibold'>{faq.question}</h2>
                <span className='text-xl'>
                  {expandedIndex === index ? '-' : '+'}
                </span>
              </div>
              {expandedIndex === index && (
                <div className='p-4'>
                  <p className='text-gray-600'>{faq.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
